import { Injectable } from '@angular/core';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';

@Injectable({ providedIn: 'root' })
export class MonthlyReportService {
    constructor(private firestore: Firestore) { }

    async fetchReport(churchId: string, periodo: string): Promise<any | null> {
        if (!churchId || !periodo) {
            return null;
        }

        const ref = doc(this.firestore, `iglesias/${churchId}/informes/${periodo}`);
        const snap = await getDoc(ref);
        return snap.exists() ? snap.data() : null;
    }
}
